import { render, staticRenderFns } from "./deletePoint.vue?vue&type=template&id=93585dc2&scoped=true"
import script from "./deletePoint.vue?vue&type=script&lang=js"
export * from "./deletePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93585dc2",
  null
  
)

export default component.exports